import React from 'react';
import { Container } from 'reactstrap';
import AwardingList from './components/AwardingList';

const AwardingPage = () => {
  document.title = 'Awarding';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <AwardingList />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AwardingPage;
